import { bestMatch, rankMatches } from '../../../resources/nameMatch';

/** tax_1099_vendors.status: 1 = active. Only these can be assigned to an expense. */
const ACTIVE_VENDOR = 1;

export interface VendorOption {
    value: number;
    label: string;
}

export const activeVendorOptions = (vendors: any[] | undefined): VendorOption[] =>
    (vendors || [])
        .filter((vendor: any) => vendor?.id && Number(vendor.status) === ACTIVE_VENDOR && `${vendor.display_name || ''}`.trim())
        .map((vendor: any) => ({ value: Number(vendor.id), label: `${vendor.display_name}`.trim() }))
        .sort((a, b) => a.label.localeCompare(b.label));

/**
 * The vendor a check's payee names, or null.
 *
 * Uses the shared name rules (resources/nameMatch), held to an exact match:
 * this screen posts what is pre-selected, and a wrong pre-selection posts money
 * to the wrong 1099. Two vendors with one name is ambiguous, so nothing is chosen.
 */
export const matchVendorByPayee = (payeeName: string | null | undefined, options: VendorOption[]): number | null =>
    bestMatch(rankMatches(payeeName, options, (option) => option.label), 1)?.value ?? null;
